import { useMemo, useContext, useRef, useEffect } from 'react';
import { isDefined, isNotDefined } from '@togglecorp/fujs';
import TileLayer$1 from '../../../node_modules/ol/layer/Tile.js';
import MapContext from '../MapContext.js';
import OSM from '../../../node_modules/ol/source/OSM.js';

function TileLayer(props) {
  const {
    source: sourceFromProps,
    zIndex = 1,
    opacity = 1
  } = props;
  const source = useMemo(() => {
    if (isDefined(sourceFromProps)) {
      return sourceFromProps;
    }
    return new OSM();
  }, [sourceFromProps]);
  const {
    map
  } = useContext(MapContext);
  const configRef = useRef({
    zIndex,
    opacity
  });
  const tileLayer = useMemo(() => new TileLayer$1({
    source,
    zIndex: configRef.current.zIndex,
    opacity: configRef.current.opacity
  }), [source]);
  useEffect(() => {
    const currentMap = map;
    const addedLayer = tileLayer;
    if (isNotDefined(currentMap) || isNotDefined(addedLayer)) {
      return undefined;
    }
    currentMap.addLayer(addedLayer);
    return () => {
      currentMap.removeLayer(addedLayer);
    };
  }, [map, tileLayer]);
  useEffect(() => {
    if (isNotDefined(tileLayer)) {
      return;
    }
    tileLayer.setOpacity(opacity);
    tileLayer.setZIndex(zIndex);
  }, [tileLayer, opacity, zIndex]);
  return null;
}

export { TileLayer as default };
//# sourceMappingURL=TileLayer.js.map
